import { render, staticRenderFns } from "./my-template-prize.vue?vue&type=template&id=f80dce5e&scoped=true&"
import script from "./my-template-prize.vue?vue&type=script&lang=js&"
export * from "./my-template-prize.vue?vue&type=script&lang=js&"
import style0 from "./my-template-prize.vue?vue&type=style&index=0&id=f80dce5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80dce5e",
  null
  
)

export default component.exports